import ApiService from './ApiService';

export default class NotificationService {
  hasVisualized(notification) {
    return ApiService.get(`/notifications/visualized?notification=${notification}`);
  }

  setVisualized(notification) {
    return ApiService.put('/notifications/visualized', { notification });
  }
}
